import Main from './main';
import Admin from './PageAdmin.vue';
import PageContent from './PageContent.vue';


export default {
	Admin,
	Main,
	PageContent,
}
